import _ from 'lodash';

export const EQUIPMENT_TYPE_IDS = {
	truck : 'truck',
};

/**
 * equipmentDescriptionId
 */

export function getEquipmentDescriptionDisplay(equipment) {
	return _.get(equipment, 'geoTabComment', '');
}

/*
export function getEquipmentDescriptionDisplay({ equipmentDescriptionId }) {
	return _.get(getEquipmentDescription({ equipmentDescriptionId }), 'display', equipmentDescriptionId);
}
*/
export function getEquipmentDescription({ equipmentDescriptionId }) {
	return _.find(getEquipmentDescriptionList(), { equipmentDescriptionId });
}
export const getEquipmentDescriptionList = _.memoize(() => {
	return [{
		equipmentDescriptionId: 'gravity-tub-2n2',
		display: 'Gravity/Tub 2&2',
		shortDisplay: 'G/T 2&2',
	}, {
		equipmentDescriptionId: 'gravity-tub-trailer',
		display: 'Gravity: Tub & Trailer',
		shortDisplay: 'Gravity T&T',
	}, {
		equipmentDescriptionId: 'pump-tub-trailer',
		display: 'Pump: Tub & Trailer',
		shortDisplay: 'Pump T&T',
	}];
});
